import React, { useState, useEffect, useCallback } from 'react';
import TaskCalendar from '../../../components/TaskCalendar';
import Add from './Add';
import api from '../../../api/axios';
import { message, Modal, Descriptions, Tag, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const STATUS_COLORS = {
    pending: '#f59e0b',
    confirmed: '#667eea',
    in_progress: '#3b82f6',
    completed: '#22c55e',
    cancelled: '#ef4444',
};

function Calendar() {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const fetchData = useCallback(() => {
        Promise.all([
            api.get('/tasks').catch(() => ({ data: { data: [] } })),
            api.get('/orders/my').catch(() => ({ data: { data: [] } })),
        ]).then(([tasksRes, ordersRes]) => {
            const tasks = (tasksRes.data?.data || []).map(t => ({
                ...t,
                _type: 'task',
                date: t.date ? dayjs(t.date).format('YYYY-MM-DD') : null,
                title: t.title,
                color: t.color || '#667eea',
                description: t.description,
                time: t.start_time ? `${String(t.start_time).slice(0, 5)} — ${String(t.end_time || '').slice(0, 5)}` : null,
            }));

            const orders = (ordersRes.data?.data || []).map(o => ({
                ...o,
                _type: 'order',
                id: `order_${o.id}`,
                _orderId: o.id,
                date: o.year && o.month && o.day
                    ? `${o.year}-${String(o.month).padStart(2, '0')}-${String(o.day).padStart(2, '0')}`
                    : null,
                title: `#${o.id} ${o.client_name || o.service_name || 'Buyurtma'}`,
                color: STATUS_COLORS[o.status] || '#667eea',
                description: `${o.service_name || ''} — ${o.summa ? Number(o.summa).toLocaleString() + " so'm" : ''}`,
                time: o.start ? `${String(o.start).slice(0, 5)} — ${String(o.end || '').slice(0, 5)}` : null,
            }));

            setEvents([...tasks, ...orders]);
        });
    }, []);

    useEffect(() => { fetchData(); }, [fetchData]);

    const handleEventClick = (ev) => {
        setSelectedEvent(ev);
    };

    const handleDeleteTask = () => {
        if (!selectedEvent || selectedEvent._type !== 'task') return;
        api.delete(`/tasks/${selectedEvent.id}`)
            .then(() => { message.success('Vazifa o\'chirildi'); fetchData(); setSelectedEvent(null); })
            .catch(() => message.error('Xatolik'));
    };

    return (
        <>
            <TaskCalendar
                events={events}
                dateKey="date"
                titleKey="title"
                AddComponent={Add}
                addModalTitle={(date) => `${date?.format('DD MMMM')} — yangi vazifa`}
                onEventClick={handleEventClick}
                onRefresh={fetchData}
            />

            <Modal
                open={!!selectedEvent}
                title={selectedEvent?._type === 'order' ? 'Buyurtma' : 'Vazifa'}
                onCancel={() => setSelectedEvent(null)}
                footer={selectedEvent?._type === 'task' ? [
                    <Button key="del" danger icon={<DeleteOutlined />} onClick={handleDeleteTask}>O'chirish</Button>,
                    <Button key="close" onClick={() => setSelectedEvent(null)}>Yopish</Button>,
                ] : [<Button key="close" onClick={() => setSelectedEvent(null)}>Yopish</Button>]}
            >
                {selectedEvent && (
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Nomi">{selectedEvent.title}</Descriptions.Item>
                        <Descriptions.Item label="Sana">{selectedEvent.date}</Descriptions.Item>
                        {selectedEvent.time && <Descriptions.Item label="Vaqt">{selectedEvent.time}</Descriptions.Item>}
                        {selectedEvent.description && <Descriptions.Item label="Tafsilot">{selectedEvent.description}</Descriptions.Item>}
                        {selectedEvent.status && <Descriptions.Item label="Holat">
                            <Tag color={STATUS_COLORS[selectedEvent.status]}>{selectedEvent.status}</Tag>
                        </Descriptions.Item>}
                    </Descriptions>
                )}
            </Modal>
        </>
    );
}

export default Calendar;